import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetPaymentHistoryApiParameter } from "@store/Services/PaymentHistoryService";
import { setDataViewLoaded, setDataViewLoading } from "@store/Store/Data/DataState";
import { PaymentsState } from "@store/Store/Data/Payment/PaymentsState";
import { PaymentCollectionModel, PaymentModel } from "@store/Types/PaymentHistory";
import { Draft } from "immer";

const initialState: PaymentsState = {
    isLoading: {},
    idByPaymentNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Store/Data/PaymentHistory/BeginLoadPaymentHistory": (
        draft: Draft<PaymentsState>,
        action: { parameter: GetPaymentHistoryApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Store/Data/PaymentHistory/CompleteLoadPaymentHistory": (
        draft: Draft<PaymentsState>,
        action: { parameter: GetPaymentHistoryApiParameter; collection: PaymentCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.paymentHistory!,
            payment => storeIdByCheckNumber(draft, payment),
        );
    },
};

function storeIdByCheckNumber(draft: Draft<PaymentsState>, payment: PaymentModel) {
    draft.idByPaymentNumber[payment.checkNumber] = payment.id;
}

const paymentsReducer = createTypedReducerWithImmer(initialState, reducer);
export default paymentsReducer;
